module.exports = __webpack_public_path__ + "ui-static/img/favicon.1c410620.svg";